import React from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import Labels from "./Labels";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";

const TextInput = ({ label, value, onChange, type, inputPropss }) => {
  return (
    <Box
      sx={{
        my: "5px",
        textAlign: "center",
        width: "100%",
      }}
    >
      <Labels text={label} />
      <TextField
        variant="outlined"
        value={value}
        onChange={onChange}
        type={type}
        InputProps={{
          sx: {
            height: "40px",
            color: getColor.NeutralDark700,
            fontSize: 30,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          },
        }}
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            fontSize: "15px",
            height: "40px",
            "& input": {
              padding: "5px",
              ml: "5px",
            },
          },
        }}
        slotProps={{
          input: {
            startAdornment: inputPropss && (
              <InputAdornment position="start">₹</InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default TextInput;
